import React, { FC } from 'react';

import COLORS from '@app/colors';

interface GolfBallProps {
  color?: string;
  size?: number;
}

const GolfBall: FC<GolfBallProps> = ({ color = COLORS.green, size = 24 }) => {
  const dimpleRadius = size * 0.06;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5" fill="none" />
      <circle cx="9" cy="10" r={dimpleRadius} fill={color} />
      <circle cx="13.5" cy="8" r={dimpleRadius} fill={color} />
      <circle cx="15.5" cy="12.5" r={dimpleRadius} fill={color} />
      <circle cx="11" cy="14.5" r={dimpleRadius} fill={color} />
      <circle cx="7.5" cy="13" r={dimpleRadius} fill={color} />
      <circle cx="14" cy="9.5" r={dimpleRadius} fill={color} />
    </svg>
  );
};

export default GolfBall;
